import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { Withholding } from '../../../models/withholding';
import { WithholdingType } from '../../../models/withholding-type';
import { findWithholdingCatalogAct, saveWithholdingCatalogAct, updateWithholdingCatalogAct } from '../../../store/withholding-catalog/withholding-catalog.action';
import { findWithholdingTypeCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';

@Component({
  selector: 'app-withholding-add',
  standalone: false,
  templateUrl: './withholding-add.component.html',
  styleUrl: './withholding-add.component.css'
})
export class WithholdingAddComponent {

  withholdingCatForm!: NgForm;
  loading = false;
  title!: string;
  withholding: Withholding = new Withholding();
  violations: any;
  withholdingTypes: WithholdingType[] = [];

  constructor(
    private route: ActivatedRoute,
    private withholdingStore: Store<{withholdingCatalogRdc: any}>,
    private catalogOfferStore: Store<{catalogOfferRdc: any}>
  ) {
    this.withholdingStore.pipe(
      select('withholdingCatalogRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        withholding: state.withholding,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ withholding, violations, loading }) => {
      //this.withholding = withholding;
      this.withholding = JSON.parse(JSON.stringify(withholding));
      this.violations = violations;
      this.loading = loading;
      this.title = 'Detalles de Benefico';

      if(this.withholdingCatForm){
      
        Object.keys(this.withholdingCatForm.controls).forEach(controlName => {
          const control = this.withholdingCatForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        withholdingTypes: state.withholdingTypes
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ withholdingTypes }) => {
      //this.withholdingTypes = withholdingTypes;
      this.withholdingTypes = JSON.parse(JSON.stringify(withholdingTypes));
    });

  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.withholdingStore.dispatch(findWithholdingCatalogAct({ id }));
      }else{
        this.withholding = new Withholding();
        this.withholding.active = true;
        this.loading = false;
        this.title = 'Agregar Beneficio';
      }
    });

    this.catalogOfferStore.dispatch(findWithholdingTypeCatalogAct());
  }

  onSubmitBenefir(withholdingCatForm: NgForm): void {
    //this.loading = true;
    this.withholdingCatForm = withholdingCatForm;
    const withholdingCopy = JSON.parse(JSON.stringify(this.withholding));
   
    if (withholdingCopy.id > 0) {
      this.withholdingStore.dispatch(updateWithholdingCatalogAct({ withholdingUpdated: withholdingCopy }))
    } else {
      this.withholdingStore.dispatch(saveWithholdingCatalogAct({ withholdingNew: withholdingCopy }))
    }
  }

  compareWithholdingTypes = (a: any, b: any) => a?.id === b?.id;
  removeSpaces() {
    this.withholding.attribute = (this.withholding.attribute ?? '').replace(/\s+/g, '');
  }  
  
}
